// Simple logging utility that can be enabled/disabled based on environment
class Logger {
  private isDebugEnabled: boolean

  constructor() {
    // Enable debug logging in development, disable in production
    // For now, enable debug in development builds, can be overridden with VITE_DEBUG env var
    this.isDebugEnabled = true // Default to enabled, can be controlled via build process
  }

  debug(message: string, ...args: any[]): void {
    if (this.isDebugEnabled) {
      console.log(`[DEBUG] ${message}`, ...args)
    }
  }

  info(message: string, ...args: any[]): void {
    console.info(`[INFO] ${message}`, ...args)
  }

  warn(message: string, ...args: any[]): void {
    console.warn(`[WARN] ${message}`, ...args)
  }

  error(message: string, ...args: any[]): void {
    console.error(`[ERROR] ${message}`, ...args)
  }
}

// Export a singleton instance
export const logger = new Logger() 